export default __webpack_public_path__ + "static/media/out-of-time.cbfd21c4.png";